module.exports = __webpack_public_path__ + "img/james-penington.366deadd.png";